// syncService.js
// Vue 2 + Dexie
// KURAL:
// - SADECE IndexDB BOŞ ise (stocks veya caris yoksa) ekran KİLİTLENİR
// - DB doluysa sync olsa bile ekran KİLİTLENMEZ
// - Sync ATLANIRSA ekran KİLİTLENMEZ

import Vue from 'vue';
import Dexie from 'dexie';
import db from '../db';
import sepet from './sepet';

export const syncState = Vue.observable({
    status: 'idle',        // idle | running | done | error
    stage: null,           // checking | fetchCari | fetchStok | writeStocks | writeCaris | finalize
    total: 0,
    processed: 0,
    message: '',
    locked: false,
    lastError: null,
    startedAt: null,
});

var isRunning = false;
var SYNC_MAX_AGE_DAYS = 1;
var WRITE_CHUNK_SIZE = 1500;

function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

function setState(patch) {
    Object.keys(patch).forEach(function (k) {
        syncState[k] = patch[k];
    });
}

/**
 * Sync atlanacak mı + DB boş mu?
 */
async function shouldSkipSync(force) {
    console.log('[SYNC] shouldSkipSync çağrıldı. force=', force);

    var counts = await Promise.all([
        db.stocks.count(),
        db.caris.count(),
    ]);

    var stokCount = counts[0];
    var cariCount = counts[1];

    var dbEmpty = (!stokCount || !cariCount);

    console.log('[SYNC] stokCount=', stokCount, 'cariCount=', cariCount);

    if (force) {
        return { skip: false, dbEmpty: dbEmpty };
    }

    // DB boşsa sync zorunlu (kilit AÇILACAK)
    if (dbEmpty) {
        return { skip: false, dbEmpty: true };
    }

    var last = localStorage.getItem('last_sync');
    if (!last) {
        return { skip: false, dbEmpty: false };
    }

    var lastTime = Date.parse(last);
    if (isNaN(lastTime)) {
        return { skip: false, dbEmpty: false };
    }

    var diffDays = (Date.now() - lastTime) / (1000 * 60 * 60 * 24);
    if (diffDays < SYNC_MAX_AGE_DAYS) {
        return { skip: true, dbEmpty: false };
    }

    return { skip: false, dbEmpty: false };
}

async function bulkPutChunked(table, list, onProgress) {
    if (!Array.isArray(list) || !list.length) return;

    if (list.length <= WRITE_CHUNK_SIZE) {
        await table.bulkPut(list);
        if (onProgress) onProgress(list.length, list.length);
        return;
    }

    var done = 0;
    for (var i = 0; i < list.length; i += WRITE_CHUNK_SIZE) {
        var chunk = list.slice(i, i + WRITE_CHUNK_SIZE);
        await table.bulkPut(chunk);

        done += chunk.length;
        if (onProgress) onProgress(done, list.length);

        await Dexie.waitFor(sleep(0));
    }
}

async function syncStocksAndCaris(api, options) {
    options = options || {};

    console.log('[SYNC] syncStocksAndCaris çağrıldı. isRunning=', isRunning);

    if (!api || typeof api.ayar !== 'function' || typeof api.post !== 'function') {
        console.warn('[SYNC] API geçersiz');
        return;
    }

    if (isRunning) {
        console.log('[SYNC] Zaten çalışıyor');
        return;
    }

    var force = !!options.force;
    var lockUI = options.lockUI !== false;

    isRunning = true;

    setState({
        status: 'running',
        stage: 'checking',
        message: 'Veriler kontrol ediliyor...',
        total: 0,
        processed: 0,
        locked: false,
        lastError: null,
        startedAt: new Date().toISOString(),
    });

    localStorage.setItem('sync_status', 'running');

    try {
        var result = await shouldSkipSync(force);
        var skip = result.skip;
        var dbEmpty = result.dbEmpty;

        // Sync atlandı
        if (skip) {
            setState({
                status: 'idle',
                stage: null,
                message: '',
                locked: false,
            });
            localStorage.setItem('sync_status', 'idle');
            return;
        }

        // ✅ SADECE DB BOŞSA kilitle
        syncState.locked = (lockUI && dbEmpty) ? true : false;

        console.log('[SYNC] SYNC BAŞLIYOR. locked=', syncState.locked);

        var source = api.ayar();

        /* ---------- CARİ ---------- */
        setState({ stage: 'fetchCari', message: 'Cari listesi alınıyor...' });

        var cariRes = await api.post(source.program + '/cariliste', {
            pkod: source.entegrekodu,
            ckod: 0,
            yetki: source.yetki.cari,
            search: null,
            sayfa: 1,
            toplam: 0,
        });

        var cariList = [];
        if (cariRes && cariRes.response) {
            cariList = cariRes.response;
        }

        /* ---------- STOK ---------- */
        setState({ stage: 'fetchStok', message: 'Stok listesi alınıyor...' });

        var stokRes = await api.post(source.program + '/stoklistV2/', {
            giden: { yetki: source.yetki },
        });

        var stokList = [];
        if (stokRes && stokRes.data) {
            stokList = stokRes.data;
        }

        /* ---------- DEXIE ---------- */
        await db.transaction('rw', db.stocks, db.caris, async function () {
            await db.stocks.clear();
            await db.caris.clear();

            setState({
                stage: 'writeStocks',
                message: 'Stoklar yazılıyor...',
                total: stokList.length,
                processed: 0,
            });

            await bulkPutChunked(db.stocks, stokList, function (done, total) {
                setState({ processed: done, total: total });
            });

            setState({
                stage: 'writeCaris',
                message: 'Cariler yazılıyor...',
                total: cariList.length,
                processed: 0,
            });

            await bulkPutChunked(db.caris, cariList, function (done, total) {
                setState({ processed: done, total: total });
            });

            var first = await db.caris.orderBy('guid').first();
            if (first) {
                await db.caris.update(first.guid, { secili: true });
            }
        });

        localStorage.setItem('last_sync', new Date().toISOString());
        localStorage.setItem('sync_status', 'done');

        setState({
            status: 'done',
            stage: null,
            message: 'Veriler güncellendi.',
        });

        var aktifCari = await db.caris
            .toCollection()
            .filter(function (c) {
                return c && c.secili === true;
            })
            .first();
        if (aktifCari) {
            sepet.set(api, aktifCari);
        }

    } catch (err) {
        console.error('[SYNC] HATA:', err);

        localStorage.setItem('sync_status', 'error');

        setState({
            status: 'error',
            stage: null,
            message: 'Veriler güncellenirken hata oluştu.',
            lastError: err && err.message ? err.message : err,
        });
        try {
            // Token temizle
            localStorage.removeItem('tfxm');

            // Aynı tab içinde sadece 1 kez yönlendir
            if (!sessionStorage.getItem('sync_redirected')) {
                sessionStorage.setItem('sync_redirected', '1');

                // Zaten oturum sayfasındaysak tekrar yönlendirme
                //if (window.location.pathname !== '#/oturum') {
                window.location.replace('/#/oturum');
                //}
            }
        } catch (e) { }


    }

    finally {
        isRunning = false;

        if (syncState.locked) {
            await sleep(50);
        }

        syncState.locked = false;

        if (syncState.status === 'running') {
            setState({ status: 'idle', stage: null, message: '' });
        }

        console.log('[SYNC] Sync bitti');
    }
}

export default {
    setcariandstok: syncStocksAndCaris,
    isRunning: function () { return isRunning; },
    state: syncState,
};



// WEBPACK FOOTER //
// ./src/services/syncService.js